import { BidAsk } from '@libs/api-reference';

type TransformSingleBidAskDataType = {
  A: number;
  B: number;
  C: number;
  R: number;
  U: number;
  V: number;
  W: number;
};

type TransformBidAskChangeDataType = {
  Y: string;
  L: TransformSingleBidAskDataType[];
};
function transformSingleBidAsk(item: TransformSingleBidAskDataType) {
  const {
    A: askNumber,
    B: askPrice,
    C: askQuantity,
    R: rowPlace,
    U: bidNumber,
    V: bidPrice,
    W: bidQuantity,
  } = item;

  return {
    rowPlace,
    bidPrice,
    bidNumber,
    bidQuantity,
    askPrice,
    askNumber,
    askQuantity,
  };
}

function transformBidAskChange(data: TransformBidAskChangeDataType) {
  const { Y: isin, L: bidAsk } = data;

  return {
    isin,
    bidAsk: bidAsk.map(transformSingleBidAsk),
  };
}

export { transformBidAskChange };
